import React, { useState } from 'react';

const WpBroadcast_Faq = () => {
    const faqs = [
        {
            q: "What is WhatsApp Broadcast?",
            a: "It’s a feature that lets you send bulk messages to multiple contacts at once on WhatsApp, without creating a group."
        },
        {
            q: "How is Broadcast different from a WhatsApp group?",
            a: "In a group, everyone sees each other’s replies. In a broadcast, each recipient gets the message as a private chat, keeping responses one-to-one."
        },
        {
            q: "How many people can I add to a broadcast list?",
            a: "On the WhatsApp Business API, you can send broadcasts to thousands of opted-in users at scale—much higher than the 256 limit of normal WhatsApp."
        },
        {
            q: "Do users need to save my number to get broadcasts?",
            a: "Yes, for personal WhatsApp broadcasts. On Business API, customers just need to opt-in once to receive your broadcasts reliably."
        },
        {
            q: "What kind of messages can I send?",
            a: "Approved templates like offers, reminders, alerts, invoices, or updates. You can include text, images, buttons, catalogs, or payment links."
        },
        {
            q: "Can I schedule or automate broadcasts?",
            a: "Yes. You can plan messages in advance, set schedules, or trigger them automatically through CRM or API integrations."
        },
        {
            q: "Will I get delivery and read reports?",
            a: "Yes. The Business API provides delivery, read receipts, and analytics to track performance and conversions."
        },
        {
            q: "Is user consent required for WhatsApp Broadcast?",
            a: "Yes. You must collect user opt-in before sending promotional or informational broadcasts to comply with Meta’s policies."
        }
    ];

    const [openIndex, setOpenIndex] = useState(0); // first open by default

    const toggle = (i) => setOpenIndex((prev) => (prev === i ? -1 : i));

    return (
        <section
            className="py-5 position-relative mb-5"
            style={{
                overflow: 'hidden',
                marginTop: "40px"
            }}
        >
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative mb-5"
                style={{ maxWidth: '74%', zIndex: 1 }}
            >
                {/* Heading */}
                <div className="mb-5">
                    <h2
                        style={{
                            fontSize: "2.5rem",
                            fontFamily: "Inter",
                            fontWeight: 700,
                            color: "#242121ff",
                            lineHeight: 1.2,
                        }}
                    >
                        FAQs for WhatsApp Broadcast Software
                    </h2>
                    <p
                        className="mt-2"
                        style={{
                            marginTop: -2,
                            color: "#413e3eff",
                            fontSize: "1.1rem",
                            fontFamily: "Poppins",
                            fontWeight: 300,
                            lineHeight: 1.2,
                        }}
                    >
                        Quick answers on{' '}
                        <span
                            style={{
                                fontFamily: 'Poppins',
                                fontWeight: 600,
                                background: 'linear-gradient(90deg, #317cbeff 0%, #59C0FB 100%)',
                                WebkitBackgroundClip: 'text',
                                backgroundClip: 'text',
                                color: 'transparent',
                            }}
                        >
                            Vertex Suite's
                        </span> automation, templates, pricing and uses- so you can start fast.
                    </p>
                </div>

                {/* FAQ list */}
                <div>
                    {faqs.map((item, i) => {
                        const isOpen = openIndex === i;
                        return (
                            <div key={i}>
                                <div
                                    className="faq-card"
                                    onClick={() => toggle(i)}
                                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && toggle(i)}
                                    role="button"
                                    tabIndex={0}
                                    aria-expanded={isOpen}
                                >
                                    <div style={{ flex: 1 }}>
                                        <h5 className="faq-q">{item.q}</h5>
                                        <p className={`faq-a ${isOpen ? 'open' : ''}`}>{item.a}</p>
                                    </div>

                                    {/* Right circular arrow */}
                                    <div
                                        className="arrow-btn"
                                        aria-hidden="true"
                                    >
                                        {/* Down arrow SVG that rotates to up when open (gives the “3D” pop with shadows above) */}
                                        <svg
                                            viewBox="0 0 24 24"
                                            className={`arrow-icon ${isOpen ? 'arrow-rotated' : ''}`}
                                        >
                                            {/* simple chevron/triangle mix for a crisp “straight bottom arrow” look */}
                                            <path d="M12 16c-.3 0-.6-.1-.8-.3l-6-6a1.1 1.1 0 0 1 1.6-1.6L12 13.7l5.2-5.6a1.1 1.1 0 1 1 1.6 1.6l-6 6c-.2.2-.5.3-.8.3z" />
                                        </svg>
                                    </div>
                                </div>

                                {/* gap between cards */}
                                {i !== faqs.length - 1 && <div className="faq-gap" />}
                            </div>
                        );
                    })}
                </div>
            </div>

            <style>{`
                 .faq-card {
                background: linear-gradient(135deg, #dce7fa, #fefefe);
               border: 1px solid #dae6fc;
               border-radius: 12px;
               padding: 18px 20px;
               display: flex;
               justify-content: space-between;
              align-items: flex-start;
              gap: 16px;
              transition: box-shadow 220ms ease, transform 220ms ease, background 220ms ease;
              cursor: pointer;
              }
      
              .faq-q {
                margin: 0;
                font-family: Lato;
                font-size: 20px;
                font-weight: 600;
                color: #242121ff;
                line-height: 1.3;
              }
              .faq-a {
                margin: 8px 0 0 0;
                font-family: Lato;
                font-weight: 400;
                font-size: 1.12rem;
                color: #413e3eff;
                line-height: 1.2;
                overflow: hidden;
                max-height: 0;
                opacity: 0;
                transition: max-height 320ms ease, opacity 240ms ease, margin 240ms ease;
              }
              .faq-a.open {
                max-height: 220px; /* large enough for content */
                opacity: 1;
                margin-top: 10px;
              }
      
              /* Right circular arrow button (3D-ish) */
              
              .arrow-btn {
               flex: 0 0 auto;
               width: 26px;
               height: 26px;
               border-radius: 999px;
               display: grid;
               place-items: center;
               border: 2px solid #3b5c92; 
               background: radial-gradient(
                  120% 120% at 30% 20%,
                  #ffffff 0%,
                  #f8faff 60%,   
                  #edf3fa 100%  
              );
              box-shadow:
              inset 0 -2px 0 rgba(0, 0, 0, 0.05), 
              inset 0 1px 0 rgba(255, 255, 255, 0.8);
              transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
              }
      
              .arrow-icon {
                width: 16px;
                height: 16px;
                fill: #0F2B54; /* navy */
                transition: transform 220ms ease;
              }
              .arrow-rotated {
                transform: rotate(180deg); /* down ↔ up */
              }
      
              /* spacing between cards */
              .faq-gap { height: 16px; }
            `}</style>
        </section>
    );
};

export default WpBroadcast_Faq